import React from 'react'

function SlideCartelera({resena, screenshot, screenshotmobile, titulo, categoria, id}) {
  return (
    <div className="SlideCartelera" key={id}>
      <div className='proximamente'>Próximamente</div>
      <div className="SlideCartelera-caption">
        <span>{categoria}</span>
        <h4>{titulo}</h4>
        <p>{resena}</p>
      </div>
      <img src={screenshotmobile} className="mobile"  />
      <figure className='img-container'>  
        <img src={screenshot} className="desktop" />
      </figure>
    </div>
  )
}

export default SlideCartelera